import React, { Component } from 'react';
import ReactDOM from 'react-dom'
import './Gallery.scss';

class Gallery extends Component {
  constructor(props) {
     super(props);

     var row,
         rowEnd;
     if (typeof(props.row) === "object") {
       row = props.row[0]
       rowEnd = props.row[1]
     }
     else {
       row = props.row;
       rowEnd = props.row;
     }

     var column,
         columnEnd;
     if (typeof(props.column) === "object") {
       column = props.column[0]
       columnEnd = props.column[1]
     }
     else {
       column = props.column;
       columnEnd = props.column;
     }

     this.renderGalleryCard = this.renderGalleryCard.bind(this);
     this.scroll = this.scroll.bind(this);
     this.getArrowTransparrency = this.getArrowTransparrency.bind(this);
     this.componentDidMount = this.componentDidMount.bind(this);

     this.state = {
       type: this.props.type,
       row: row,
       column: column,
       rowEnd: rowEnd,
       columnEnd: columnEnd,
       image: this.props.image,
       contents: this.props.contents,
       leftArrowTransparrency: " Gallery-arrow-transparrent",
       rightArrowTransparrency: ""
     };

  }

  componentDidMount() {
    ReactDOM.findDOMNode(this).querySelector(".Gallery-grid-outer").addEventListener("scroll", this.getArrowTransparrency);
  }

  scroll(amount) {
    var w = ReactDOM.findDOMNode(this).querySelector(".Gallery-grid-outer")

    var start = w.scrollLeft,
        // end = w.scrollWidth - w.offsetWidth,
        end = Math.min(Math.max(0, w.scrollLeft + amount), w.scrollWidth - w.offsetWidth),
        duration = 1000,
        easing = easeInOutCubic;

    amount = end - start;

    var delta = end - start;
    var startTime;
      if (window.performance && window.performance.now) {
        startTime = performance.now();
      }
      else if (Date.now) {
        startTime = Date.now();
      }
      else {
        startTime = new Date().getTime();
      }
      var tweenLoop = function (time) {
      var t = (!time ? 0 : time - startTime);
      var factor = easing(null, t, 0, 1, duration);
      w.scrollLeft = start + delta * factor;

      if (t < duration && w.scrollLeft !== end) {
        requestAnimationFrame(tweenLoop);
      }
    }
    tweenLoop();

    this.getArrowTransparrency(null, amount)
  }

  //change arrow transparrency based on scroll position
  getArrowTransparrency(e, amount=0) {
    var w = ReactDOM.findDOMNode(this).querySelector(".Gallery-grid-outer")

    this.setState({
      leftArrowTransparrency: (w.scrollLeft + amount === 0) ? " Gallery-arrow-transparrent" : "",
      rightArrowTransparrency: (w.scrollWidth - w.scrollLeft - w.offsetWidth - amount === 0) ? " Gallery-arrow-transparrent" : ""
    })

  }

  renderGalleryCard(content, i) {
    return (
      <div key={content.image + i} className="Gallery-item">
        <img className="Gallery-image" src={content.image} onClick={e => this.props.onClick(e, {image: content.image})} alt="" />
      </div>
    )
  }

  render() {

    return (
      <div className={`Gallery
                       Card-position-${this.state.row}-${this.state.column}
                       Card-span-${this.state.rowEnd}-${this.state.columnEnd}`}>
        <div className="Gallery-container">

          <button className={"Gallery-arrow Gallery-arrow-left" + this.state.leftArrowTransparrency} onClick={d => this.scroll(-700)}>
            <svg className="Gallery-arrow-icon" width="23" height="36">
              <path d="M155,260 L153.5,261 l-18.5-18,18.5-18,1.5,1.5 L138,243 Z" transform="translate(-133 -225)"></path>
            </svg>
          </button>

          <button className={"Gallery-arrow Gallery-arrow-right" + this.state.rightArrowTransparrency} onClick={d => this.scroll(700)}>
            <svg className="Gallery-arrow-icon" width="23" height="36">
              <path d="M-154.994,259.522L-153.477,261l18.471-18,-18.473-18,-1.519,1.48L-138.044,243Z" transform="translate(156 -225)"></path>
            </svg>
          </button>

          <div className="Gallery-grid-outer">
            <div className="Gallery-grid-inner">
              {this.state.contents.map(this.renderGalleryCard)}
            </div>
          </div>

        </div>
      </div>
    )
  }
}

export default Gallery;


//
// utils
//

// xBrowser requestAnimationFrame()
(function() {
	var lastTime = 0;
	var vendors = ['ms', 'moz', 'webkit', 'o'];
	for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
		window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
		window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame'] || window[vendors[x]+'CancelRequestAnimationFrame'];
	}
	if (!window.requestAnimationFrame)
		window.requestAnimationFrame = function(callback, element) {
			var currTime = new Date().getTime();
			var timeToCall = Math.max(0, 16 - (currTime - lastTime));
			var id = window.setTimeout(function() { callback(currTime + timeToCall); }, timeToCall);
			lastTime = currTime + timeToCall;
			return id;
		};
	if (!window.cancelAnimationFrame)
		window.cancelAnimationFrame = function(id) {
			clearTimeout(id);
		};
}());

function easeInOutCubic(x, t, b, c, d) {
  if ((t/=d/2) < 1) return c/2*t*t*t + b;
  return c/2*((t-=2)*t*t + 2) + b;
}
